import Layers from "slotworks/graphics/layers/layers";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import AbstractButtonControl from "../abstract/abstract-button-control";

export default class AutoplayCountNoLimitButtonControl extends AbstractButtonControl implements Control {
    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
    }

    public updateOptions(options: ControlOptions) {
        if (options.autoplays.values.indexOf(Infinity) === -1) {
            this.setVisible(false);
        }

        if (options.autoplays.currentValue === Infinity) {
            this.button.setSelected(true);
        } else {
            this.button.setSelected(false);
        }

        super.updateOptions(options);
    }

    protected onClick() {
        const options = new ControlOptions();
        options.autoplays.currentValue = Infinity;
        this.onChange.dispatch(options);
    }
}
